
import {Component, Prop, VModel} from "vue-property-decorator";
import Vue from "vue";
import {authentication} from "@pazion/pazion-core/src/store";
import {getDossierStatuses, updateDossierProperties} from "@pazion/pazion-core/src/services/dossier-service"
import DossierProperty from "./DossierProperty.vue";
import PazTooltipButton from '@pazion/pazion-core/src/components/controls/PazTooltipButton.vue';
import PazToast from "@pazion/pazion-core/src/components/utils/PazToast.vue";

@Component({
  components: {DossierProperty, PazTooltipButton, PazToast}
})
export default class DossierProperties extends Vue {

  $refs!: {
    toast: PazToast
  };

  @VModel()
  public dossier!: object;

  @Prop()
  public details!: object

  public statusList = [];
  public dossierStatus: string = '';
  public dossierStatusOrg: string = '';
  public dossierName: string = '';
  public dossierNameOrg: string = '';
  public saving: boolean = false;

  mounted() {
    this.fetchStatusList();
    this.dossierStatus = this.details.status;
    this.dossierStatusOrg = this.details.status;
    this.dossierName = this.details.name;
    this.dossierNameOrg = this.details.name;
  }

  async fetchStatusList() {
    this.statusList = await getDossierStatuses();
  }

  get canEdit() {
    return authentication.isAdmin;
  }
  get isDraft(){
    return 'DRAFT' == this.details?.status;
  }
  get isClosed(){
    return 'CLOSED' == this.details?.status;
  }

  async resetReminder() {
    this.saving = true;
    let rsp = await updateDossierProperties(this.details.id, {sendReminder:true, remindedAt: '2000-01-01 06:44:33'});
    if(rsp.status === 'OPEN'){
      this.$emit('reloadData');
    }
    this.saving=false;
  }
  async openDossier() {
    this.saving = true;
    let rsp = await updateDossierProperties(this.details.id, {status: 'OPEN', sendToCustomer:true, remindedAt: null});
    if(rsp.status === 'OPEN'){
      this.$emit('reloadData');
    }
    this.saving=false;
  }

  async saveDossierStatus() {
    this.saving = true;
    let rsp = await updateDossierProperties(this.details.id, {status: this.dossierStatus});
    if (this.dossierStatus == rsp.status) {
      this.$refs.toast.show({message: 'Status aangepast naar `' + rsp.status + '`'});
    }
    this.dossierStatusOrg = rsp.status;
    this.$emit('reloadData');
    this.saving = false;
  }

  async saveDossierName() {
    this.saving = true;

    let rsp = await updateDossierProperties(this.details.id, {name: this.dossierName});
    if (this.dossierName == rsp.name) {
      this.$refs.toast.show({message: 'Naam aangepast naar `' + rsp.name + '`'});
      this.dossierNameOrg = rsp.name;
      this.$emit('reloadData');
    }
    this.saving = false;
  }

  get filteredProps() {
    return this.dossier;
  }

  get getStatusList() {
    let statusList = [];
    if (this.statusList.hasOwnProperty(this.dossierStatusOrg)) {
      return this.statusList[this.dossierStatusOrg];
    }
    return [];
  }
}
